import { Pipe, PipeTransform } from "@angular/core";
import { CustomerTaxCategory, DealType, OverdueCategory, PaymentMethod } from "../model";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
    standalone: true,
    name: 'dealType',
    pure: true
})
export class DealTypePipe implements PipeTransform {

    constructor(protected translateService: TranslateService) {

    }

    transform(value: DealType): string {
        if (value === DealType.NEW_CUSTOMER) {
            return 'New Customer';
        } else if (value === DealType.RENEWAL) {
            return 'Renewal';
        } else if (value === DealType.UPSELLING) {
            return 'Upselling';
        } else if (value === DealType.MANUAL) {
            return 'Manual';
        } else if (value === DealType.NO_RENEWAL) {
            return 'No Renewal';
        } else if (value === DealType.OVERDUE) {
            return 'Overdue';
        } else {
            return '-';
        }
    }

}
